import { sendGoogleEvent } from '@html/_common/utils';

export default class AOTourRateTranslation {
  constructor(common, $block) {
    this.common = common ?? { sendGoogleEvent };
    this.$block = $block;

    this.TRANSLATED_BLOCK_SELECTOR = '.translated-block';
    this.RATE_LINK_SELECTOR = '.js-rate-link';
    this.RATE_BLOCK_SELECTOR = '.js-rate-block';
    this.STAR_SELECTOR = '.js-rate-star';

    this.ACTIVE_BLOCK_CLASS = 'rate-block--active';
    this.ACTIVE_STAR_CLASS = 'rate-star--active';
    this.HIDDEN_CLASS = 'hid';

    // GA
    this.eventCategory = 'Translation rating';

    this.$translatedBlock = this.$block.find(this.TRANSLATED_BLOCK_SELECTOR);
  }

  initiate() {
    if (!this.$translatedBlock.length) {
      return;
    }

    this.initBlock();
    this.initStars();
  }

  initBlock() {
    this.$translatedBlock.find(this.RATE_LINK_SELECTOR).click(() => {
      this.$translatedBlock
        .find(this.RATE_BLOCK_SELECTOR)
        .toggleClass(this.HIDDEN_CLASS);
    });
  }

  initStars() {
    const $rateBlock = this.$translatedBlock.find(this.RATE_BLOCK_SELECTOR);

    $rateBlock.find(this.STAR_SELECTOR).click((event) => {
      $rateBlock.addClass(this.ACTIVE_BLOCK_CLASS);
      $rateBlock.find(this.STAR_SELECTOR).removeClass(this.ACTIVE_STAR_CLASS);

      const starIndex = $(event.currentTarget).index();
      const gaAction = this.$translatedBlock.data('action');
      let i;

      for (i = 0; i <= starIndex; i += 1) {
        $rateBlock.find(this.STAR_SELECTOR).eq(i).addClass(this.ACTIVE_STAR_CLASS);
      }

      this.$translatedBlock
        .find(this.RATE_BLOCK_SELECTOR)
        .addClass(this.HIDDEN_CLASS);

      this.common.sendGoogleEvent(
        this.eventCategory,
        gaAction,
        starIndex + 1,
      );
    });
  }
}
